export const toUrlWithQueryStrings = (location: Location): string => {
    return `${location.pathname}${location.search}`
}